import Response from "../../Data/Domain/Response";
import CarbonCredits from "../Domain/CarbonCredits";
import { getCarbonCredits } from "./CarbonCredits.service";

export async function getCarbonCreditsRepository(params) {
  const data = await getCarbonCredits(params);
  return new Response(data, CarbonCredits).getMultiple();
}